<template>
  <div>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-row v-if="!isLoading">
      <v-col>
        <Layout1 />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Layout1 from "../../components/article_layout/Layout1";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
// import Layout2 from "../../components/article_layout/Layout2";

export default {
  components: {
    Layout1,
    Loading
    // Layout2 // TODO :: didn't see it's on design
  },
  async created() {
    this.items[0].text = this.branchName;
    this.isLoading = true;
    await this.$store.dispatch('Article/onGetArticleById', { id: this.$route.params.id, lang: this.lang });
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      article: state => state.Article.article
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  data: () => ({
    item: {
      id: 1,
      layout: 1
    },
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "SERVICE",
        disabled: false,
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "ARTICLE",
        href: "/service/resource-center/article"
      }
    ]
  })
};
</script>

<style>
</style>
